import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import Button, { ButtonProps } from "@insite/mobius/Button";
import Link from "@insite/mobius/Link";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import ADIColors from "@NA/Utils/ADIColors";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import WarningIcon from "@NA/Icons/WarningIcon";
import Icon from "@insite/mobius/Icon";

const mapStateToProps = (state: CustomApplicationState) => ({
    ADIRMAConfirmReturns: state?.ADIGlobalData?.ADIRMAConfirmReturns,
});

const mapDispatchToProps = {};

type Props = WidgetProps & HasHistory & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ReturnHistoryFilterStyles {
    rmaReturnConfirmWrap?: InjectableCss;
    rmaReturnConfirmHaeder?: InjectableCss;
    rmaReturnConfirmationshippingWarnmsg?: InjectableCss;
    rmaSubmittedText?: InjectableCss;
    rmaReturnIdText?: InjectableCss;
    recommendedText?: InjectableCss;
    dropOffText?: InjectableCss;
    rmaEmailInfoText?: InjectableCss;
    rmaReturnAllLink?: InjectableCss;
    rmaReturnConfirmBody?: InjectableCss;
    rmaReturnConfirmBox?: InjectableCss;
    container?: GridContainerProps;
    RMAStatusColumn1GridItem?: GridItemProps;
    RMAStatusColumn2GridItem?: GridItemProps;
    RMAStatusColumn3GridItem?: GridItemProps;
    RMAStatusColumn4GridItem?: GridItemProps;
    rmaReturnConfirmInfo?: InjectableCss;
    rmaReturnConfirmItem?: InjectableCss;
    rmaReturnConfirmReason?: InjectableCss;
    rmaReturnConfirmOption?: InjectableCss;
    rmaReturnConfirmDescription?: InjectableCss;
    rmaReturnConfirmFooter?: InjectableCss;
    noteText?: InjectableCss;
    rmaReturnConfirmBtn?: ButtonProps;
    rmaReturnConfirmContent?: InjectableCss;
}

export const returnHistoryFilterStyles: ReturnHistoryFilterStyles = {
    rmaReturnConfirmWrap: {
        css: css`
            display: flex ;
            flex-direction: column;
            align-items: center;
        `,
    },
    rmaReturnConfirmHaeder: {
        css: css`
            font-size: 1.2em !important;
            padding: 1rem;
            margin: 0.4em 0;
            color: #222;
            font-weight: bold;
            font-family: inherit;
            display: flex;
            flex-direction: column;
            align-items:center;
        `,
    },
    rmaReturnConfirmationshippingWarnmsg: {
        css: css`
            font-size: 1.2em !important;
            padding: 1rem;
            margin: 0.4em 0;
            color: #222;
            font-weight: bold;
            font-family: inherit;
            display: flex !important;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border: 2px solid #ebe8e8 !important;
            border-radius: 5px;
            font-size: 16px !important;
        `,
    },
    rmaSubmittedText: {
        css: css`
            font-size:36px;
            color: #002856;
            font-weight: bold;
        `
    },
    rmaReturnIdText: {
        css: css`
            font-size:20px;
            padding-top:15px;
            color: #002856;
            font-weight: bold;
        `
    },
    rmaEmailInfoText: {
        css: css`
            font-size:16px;
            color: #2d2926;
            font-weight: normal;
        `
    },
    rmaReturnAllLink: {
        css: css`
            font-size: 0.7em;
            color: #03f;
            margin: auto 1em;
            display: inline-block;
        `,
    },
    rmaReturnConfirmBody: {
        css: css``,
    },
    rmaReturnConfirmBox: {
        css: css`
            padding: 0.5em 1em;
            border-bottom: solid 1px #eee;
            font-size: 12px;
        `,
    },
    container: {
        css: css`
            ${GridItemStyle} {
                padding: 0px;
                padding-left: 0.9375rem;
                padding-right: 0.9375rem;
            }
            ${GridOffset} {
                margin: 0px;
            }
        `,
    },
    RMAStatusColumn1GridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
        display:flex;
        flex-direction:column;
        align-items:center;
            img {
                width: 110px;
            }
        `,
    },
    recommendedText: {
        css: css`
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #2d2926;
        padding-top: 10px;
        `
    },
    dropOffText: {
        css: css`
            font-size:20px;
            font-weight: bold;
            color:#002856;
            padding-top:15px;
            line-height:1.3;
            text-align:center;
        `
    },
    RMAStatusColumn2GridItem: {
        width: [12, 12, 2, 2, 2],
        css: css`
            img {
                width: 110px;
            }
        `,
    },
    RMAStatusColumn3GridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            font-size: 11px;
            h4 {
                font-size: 12px;
                font-weight: bold;
            }
        `,
    },
    RMAStatusColumn4GridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            font-size: 12px;
        `,
    },
    rmaReturnConfirmInfo: {
        css: css``,
    },
    rmaReturnConfirmItem: {
        css: css`
            span {
                width: 25%;
                display: inline-block;
                font-weight: 600;
            }
        `,
    },
    rmaReturnConfirmContent: {
        css: css`
            width: 100%;
        `,
    },
    rmaReturnConfirmReason: {
        css: css`
            width: 100%;
        `,
    },
    rmaReturnConfirmOption: {
        css: css`
            p {
                width: 100%;
                display: block;
                font-weight: 600;
            }
            span {
                width: 100%;
                display: block;
            }
        `,
    },
    rmaReturnConfirmDescription: {
        css: css``,
    },
    rmaReturnConfirmFooter: {
        css: css`
            padding-top: 2em;
            display: flex;
            flex-direction:column;
            align-items: center;
            justify-content: center;
            font-size: 12.8px;
            row-gap: 1.6rem;
        padding-bottom:75px;
            h4 {
                color: #c60f13;
                font-weight: bold;
                display: inline-block;
                margin: 1em 0;
                font-size: 12.8px;
            }
        `,
    },
    noteText: {
        css: css`
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #2d2926;
        width:76%;
        `
    },
    rmaReturnConfirmBtn: {
        css: css`
            height: 25px;
            min-height: 15px;
            background-color: ${ADIColors.lightblue4};
            display: inline-block;
            font-family: inherit;
            font-weight: 700;
            line-height: 100%;
            padding: 6px 15px;
            text-decoration: none;
            box-shadow: none;
            border: 0;
            text-align: center;
            color: ${ADIColors.white};
            min-width: 100px;
            border-radius: 0;
            font-size: 12.8px;
            ${TypographyStyle} {
                font-size: 12.8px;
            }
        `,
    },
};

const styles = returnHistoryFilterStyles;
interface returnsDataResponse {
    uri: string | null;
    returnCode: string;
    returnMessage: string | null;
    returnId: string;
    status: string;
    products: {
        orderNumber: string;
        partNumber: string;
        qty: number;
        techRA: string | null;
        serialNumbers: string | null;
        type: string | null;
        defectReason: string | null;
        returnReason: string | null;
        option: string | null;
        description: string | null;
    }[];
    properties: Record<string, any>; // Can be any key-value pair
    isSuccessFlag: boolean;
}

const RMAReturnConfirmation = ({ ADIRMAConfirmReturns }: Props) => {
    const [returnsData, setReturnsData] = useState<any>([]);
    const [returnTypeLabels, setReturnTypeLabels] = useState<any>({});
    const [upsShippingLabelsLink, setUpsShippingLabelsLink] = React.useState("");
    const [saveMethod, setsaveMethod] = useState<string>("")
    const [saveMethodretrun, setsaveMethodretrun] = useState<any>()
    const [webRetrunID,setwebReturnID] = useState<{returnId:String}>( JSON.parse(sessionStorage.getItem("ADIRMAConfirmReturns") || "{}"));
    const getSessionData = () => {
        let storedUserData = sessionStorage.getItem("productsToBeReturned");
        if (storedUserData) {
            let getReturns = JSON.parse(storedUserData);
            let checkType = {
                CN: "Credit - New",
                CR: "Credit - Defective Item",
                RR: "Repair",
                RX: "Exchange - Defective Item",
            };
            setReturnsData(getReturns);
            setReturnTypeLabels(checkType);
        }
    };

    useEffect(() => {
        getSessionData();

        return () => {
            //  resetAdiReturnsState({});     
        };
    }, []);

    const getTypeLabel = (type: string) => {
        return returnTypeLabels[type];
    };
    const customerResponseMsg = (product: any) => {
        let out = "";
        try {
            var type = product.custOptions.filter((opt: any) => opt.type === product.selection.type)[0];
            var opt = type.options.filter((opt: any) => opt.value === product.selection.option)[0];
            out = opt.label;
        } catch (exp) {

        }
        return out;

    };
    const getDescription = (product: any) => {
        let outStr = product.selection.description;
        if (product.selection.defectReason) {
            outStr = `${product.selection.defectReason}: ${outStr}`;
        }
        return outStr;
    };
    const printShippingLabels = () => {
        let tempUpsShippingLabelsLink;
        if (returnsData) {
            // Determine Shipping link
            returnsData.products?.forEach((prd: any) => {
                if (prd.upsShippingLabelUrl && upsShippingLabelsLink !== prd.upsShippingLabelUrl) {
                    // Assuming you have a state variable to store the link
                    // Set the link in state using a state updater function
                    tempUpsShippingLabelsLink = prd.upsShippingLabelUrl;
                    setUpsShippingLabelsLink(prd.upsShippingLabelUrl);
                }
            });
        }

        if (tempUpsShippingLabelsLink) {
            window.open(tempUpsShippingLabelsLink, "_blank");
        }
    };
    useEffect(() => {
        sessionStorage.setItem("setReturnID",ADIRMAConfirmReturns?.rmaConfirmReturnState?.returnId)
        sessionStorage.setItem("returnSubmitRequest", "");
        let returnProductsLabels: any = sessionStorage.getItem("returnProductsLabels");
        const productsSelectedForReturnResponse = JSON.parse(returnProductsLabels);
        setsaveMethodretrun(productsSelectedForReturnResponse);
        // const saveMethodlabel: any = sessionStorage.getItem("returnSubmitRequest");
        // const saveMethod_RMAsubmit: any = JSON.parse(saveMethod);
        const saveMethod_shippingLabel: string | null = sessionStorage.getItem("saveMethodLabel")
        if (saveMethod_shippingLabel) {
            setsaveMethod(saveMethod_shippingLabel)
        }
        else if (saveMethod_shippingLabel == null) {
            setsaveMethod("")
        }
        else {
            setsaveMethod("")
        }
    }, [])
    return (
        <>
            <StyledWrapper {...styles.rmaReturnConfirmWrap}>
                <StyledWrapper {...styles.rmaReturnConfirmHaeder}>
                    <Typography as="h1" {...styles.rmaSubmittedText}>{translate(`Your request has been submitted.`)}</Typography>
                    <Typography as="h6" {...styles.rmaReturnIdText} >{`${translate("Your Web Return ID is")} ${webRetrunID?.returnId}`}</Typography>
                    <Typography as="p" {...styles.rmaEmailInfoText} >{translate("If you are shipping your return, our shipping label will be delivered via email. Your return will be completed when we receive your item(s).")}</Typography>
                </StyledWrapper>
                {(saveMethod === "Shipping Label") && (saveMethodretrun?.status === "Fail") && (<StyledWrapper {...styles.rmaReturnConfirmationshippingWarnmsg}>
                    <Icon src={WarningIcon} color="danger" />
                    <Typography>
                        {translate('We were unable to process your request for a shipping label. Please contact Returns Department at')}
                    </Typography>
                    <Link as="a" href="tel:502-961-5400">502.961.5400</Link>
                </StyledWrapper>)}

                <StyledWrapper {...styles.rmaReturnConfirmBody}>
                    <StyledWrapper {...styles.rmaReturnConfirmBox}>
                        <GridContainer {...styles.container}>
                            <GridItem {...styles.RMAStatusColumn1GridItem}>
                                <img src={'https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Themes/Images/icons/drop-return.svg'} alt={'dropReturn'} />
                                <Typography as="div" {...styles.dropOffText} >{translate('Drop-off your Return Within 3 Business Days')}</Typography>
                                <Typography as="div" {...styles.recommendedText} >{translate('We recommend dropping off returns at a branch location or shipping the product within 3 business days to ensure we receive the goods promptly.')}</Typography>

                            </GridItem>
                            <GridItem {...styles.RMAStatusColumn1GridItem}>
                                <img src={"https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Themes/Images/icons/returns.svg"} alt={'returns'} />
                                <Typography as="div" {...styles.dropOffText} >{translate('Receipt of Returns Within 7 Days')}</Typography>
                                <Typography as="div" {...styles.recommendedText} >{translate('ADI must receive returns within 7 days for efficient processing. Delays may impact the assessment and approval of the return.')}</Typography>

                            </GridItem>
                            <GridItem {...styles.RMAStatusColumn1GridItem}>
                                <img src={'https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Themes/Images/icons/online-account.svg'} alt={'onlineaccount'} />
                                <Typography as="div" {...styles.dropOffText} >{translate('Communication on Issues or Concerns')}</Typography>
                                <Typography as="div" {...styles.recommendedText} >{translate('Upon receiving your return, we will contact you promptly if any issues or concerns arise during the assessment.')}</Typography>

                            </GridItem>
                            <GridItem {...styles.RMAStatusColumn1GridItem}>
                                <img src={'https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Themes/Images/icons/success.svg'} alt={'success'} />
                                <Typography as="div" {...styles.dropOffText} >{translate('Return Approval and Credit Memo')}</Typography>
                                <Typography as="div" {...styles.recommendedText} >{translate("Approved returns will be credited back to your account via a credit memo within 3-5 business days. This will be visible online in your 'Invoices' and 'Return Status' dashboard. You can apply the credited amount to future payments of an invoice, providing a seamless and transparent process.")}</Typography>

                            </GridItem>

                        </GridContainer>
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.rmaReturnConfirmFooter}>
                    <Typography as="p" {...styles.noteText}>{translate("Please note: Approval of Returns is subject to ADI's")} <Link as="a" href="/returns">{translate("Return Policy")}</Link>. {translate("Returns of special ordered items are subject to the vendor’s return policy;")}
                        {translate("some may have a restocking fee, and some may be non-returnable.")}
                    </Typography>
                    <Typography as="p" {...styles.noteText}>{translate('For any inquiries, please contact the ADI Returns Department at')} <Link as="a" href="tel:502-961-5400">502.961.5400</Link> {translate("or email us at")} <Link as="a" href="mailto:ADIUSReturnCenter@adiglobal.com">ADIUSReturnCenter@adiglobal.com</Link>.
                    </Typography>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RMAReturnConfirmation),
    definition: {
        group: "Basic",
        displayName: "ADI RMA Return Confirmation",
    },
};

export default widgetModule;
